import { emptyStateImgLink } from './constant';

export const emptyStateProp = {
  header: '',
  description: 'No details to show',
  imageUrl: emptyStateImgLink,
};
